import React, { createContext, useContext, useEffect, useState } from "react"

const TabsContext = createContext()

const Tabs = ({ defaultValue, children }) => {
  const [activeTab, setActiveTab] = useState(defaultValue)
  useEffect(() => {
    setActiveTab(defaultValue)
  }, [defaultValue])

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>
      <div>{children}</div>
    </TabsContext.Provider>
  )
}

const TabsList = ({ className = "", children }) => {
  return (
    <div
      className={`inline-flex h-10 items-center justify-center rounded-md bg-gray-200 p-1 text-gray-500 ${className}`}
    >
      {children}
    </div>
  )
}

const TabsTrigger = ({ value, className = "", children }) => {
  const { activeTab, setActiveTab } = useContext(TabsContext)
  const isActive = activeTab === value

  return (
    <button
      onClick={() => setActiveTab(value)}
      className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-colors duration-200 ${
        isActive ? "bg-white text-black shadow-sm rounded-md" : "text-gray-500"
      } focus:outline-none focus:ring-0 ${className}`}
    >
      {children}
    </button>
  )
}

const TabsContent = ({ value, className = "", children }) => {
  const { activeTab } = useContext(TabsContext)

  return (
    <div
      className={`transition-opacity duration-300 ease-in-out ${
        value === activeTab ? "opacity-100" : "opacity-0 absolute pointer-events-none"
      } ${className}`}
    >
      {children}
    </div>
  )
}


export { Tabs, TabsList, TabsTrigger, TabsContent }
